// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"fffb6211","206":"ede4f8d6","270":"cdca11d3","647":"72c944f2","960":"5e3b2f5b"}[chunkId] + ".chunk.js";
};